import { render, staticRenderFns } from "./ContactModal.vue?vue&type=template&id=074612c2"
import script from "./ContactModal.vue?vue&type=script&lang=ts"
export * from "./ContactModal.vue?vue&type=script&lang=ts"
import style0 from "./ContactModal.vue?vue&type=style&index=0&id=074612c2&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports